<template>
  <PageTemplate :class="componentClass" :title="metaTitle">
    <BannerWidget
      class="mb-4 mb-md-10"
      category="Retângulo"
      type="carousel"
      :items-to-show="{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }"
    />

    <div class="article-route-template_content">
      <div v-if="parsedTitle || item.subtitle" class="mb-2">
        <div v-if="parsedTitle" class="text-h5 text-sm-h4 font-weight-black">
          {{ parsedTitle }}
        </div>
        <div v-if="item.subtitle" class="text-body-2 font-weight-bold mt-2">
          {{ item.subtitle }}
        </div>
      </div>

      <div class="d-flex justify-space-between align-center mb-4">
        <div class="text-body-2">
          <div
            v-if="parsedAuthor"
            class="font-weight-bold grey--text text--darken-2"
          >
            Por: {{ parsedAuthor }}
          </div>
          <div v-if="parsedDate">
            <v-icon size="12">fas fa-calendar-alt</v-icon>
            {{ parsedDate }}
          </div>
        </div>
        <ShareButtonWidget :small="xsOnly" />
      </div>

      <figure class="mb-2">
        <img v-if="parsedImg" loading="lazy" :src="parsedImg" />
        <figcaption
          v-if="item.photo_author"
          class="text-body-2 font-weight-bold grey--text text--darken-2"
        >
          Foto por: {{ item.photo_author }}
        </figcaption>
      </figure>

      <div
        v-if="item.text"
        class="ck-content font-weight-medium mb-4"
        v-html="item.text"
      ></div>

      <VideoSection v-if="item.video" class="mb-4" :link="item.video" />
      <GallerySection
        v-if="gallerySection.items.length > 1"
        v-bind="gallerySection"
        no-container
      />
    </div>
  </PageTemplate>
</template>

<script>
import GallerySection from "../components/sections/GallerySection.vue";
import VideoSection from "../components/sections/VideoSection.vue";
import BannerWidget from "../components/widgets/BannerWidget.vue";
import PageTemplate from "../components/templates/PageTemplate.vue";
import ShareButtonWidget from "../components/widgets/ShareButtonWidget.vue";

/**
 * $route.meta = {
 *   mod: string; // Chave do módulo.
 *   ?title: string | (component) => string; // Título da página.
 *   ?params: Record<string, string> | (component) => Record<string, string>; // Parametros da requisição de dados
 *   ?fullWidth: boolean // Se tiver essa propriedade, o template vai ficar 100% do container.
 * }
 */
export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    metaTitle() {
      const metaTitle = this.$route.meta.title;

      if (!metaTitle) {
        return this.$route.name;
      }

      if (typeof metaTitle === "function") {
        return metaTitle(this);
      } else {
        return metaTitle;
      }
    },
    mod() {
      return this.$route.meta.mod;
    },
    fullWidth() {
      return this.$route.meta.fullWidth;
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    item() {
      return this.$rest(this.mod).item;
    },
    parsedTitle() {
      return this.item.title?.replace(/\\"/g, '"');
    },
    parsedImg() {
      const path = this.item.img?.featured?.path;

      return path ? this.files + path + "?resize=1&w=600" : null;
    },
    parsedDate() {
      return this.item.date
        ? new Date(this.item.date).toLocaleDateString("pt-BR", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : null;
    },
    parsedAuthor() {
      if (typeof this.item.author === "string") {
        return this.item.author;
      } else {
        return this.item.author?.title;
      }
    },
    gallerySection() {
      const gallerySection = {};

      gallerySection.items = this.item.img?.list || [];
      gallerySection.items = gallerySection.items.map(({ path }) => ({
        src: this.files + path,
        thumbnail: this.files + path + "?resize=1&w=112",
      }));

      gallerySection.cols = {
        xs: 2,
        sm: 3,
        md: 3,
        lg: 4,
        xl: 4,
      };

      return gallerySection;
    },
    audios() {
      return this.item.audio?.list || [];
    },
    attachments() {
      return this.item.files?.list || [];
    },
    componentClass() {
      return this.fullWidth && "article-route-template_full";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  watch: {
    itemId() {
      this.$rest(this.mod)
        .get({ id: this.itemId })
        .catch(() => this.$router.replace({ path: "/erro404" }));
    },
  },
  created() {
    this.$rest(this.mod)
      .get({ id: this.itemId })
      .catch(() => this.$router.replace({ path: "/erro404" }))
      .finally(() => (this.loading = false));
  },
  components: {
    BannerWidget,
    GallerySection,
    VideoSection,
    PageTemplate,
    ShareButtonWidget,
  },
};
</script>

<style lang="scss">
.article-route-template_content {
  figure {
    max-width: 720px;
    margin: 0 auto;
  }
  img {
    width: 100%;
    border-radius: 12px;
  }
}
</style>
